import { render, staticRenderFns } from "./HelpMsgMethodBrexCreation.vue?vue&type=template&id=0551885b"
import script from "./HelpMsgMethodBrexCreation.vue?vue&type=script&lang=js"
export * from "./HelpMsgMethodBrexCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports